import { useTranslator } from '@Localization';
import { countries } from 'countries-list';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Select } from '../../../../../../design/inputs/select/Select';
import { PersonalInformationRow } from './PersonalInformationRow';

interface IProps {
  country: string;
  onChange(country: string): Promise<void>;
}

export const CountryRow = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const options = Object.entries(countries).map(([key, value]) => ({
    value: key,
    label: value.name,
  }));

  return (
    <PersonalInformationRow label='country'>
      <Select
        placeholder={t('enter_country')}
        value={options.find((x) => x.value === props.country)}
        onChange={(_, v) => {
          void props.onChange(v.value ?? '');
        }}
        options={options}
      />
    </PersonalInformationRow>
  );
});
